import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { MdAdd } from 'react-icons/md';
import axios from '../lib/axios';
import { endpoints } from '../constants/endpoints';
import DocumentList from '../components/DocumentList';
import UploadModal from '../components/UploadModal';
import type { DocumentListResponse } from '../types';

const PAGE_SIZE = 10;

export default function Sources() {
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [page, setPage] = useState(1);

  const skip = (page - 1) * PAGE_SIZE;

  const { data, isLoading } = useQuery({
    queryKey: ['documents', page],
    queryFn: async () => {
      const response: DocumentListResponse = await axios.get(
        endpoints.documents.list(skip, PAGE_SIZE),
      );
      return response;
    },
  });

  const documents = data?.documents ?? [];
  const total = data?.total ?? 0;
  const totalPages = Math.ceil(total / PAGE_SIZE);

  if (isLoading) {
    return (
      <div className="flex h-screen flex-col">
        <div className="border-b border-gray-200 bg-white px-6 py-3">
          <h1 className="text-lg font-semibold text-gray-900">Sources</h1>
        </div>
        <div className="flex flex-1 items-center justify-center">
          <div className="text-gray-500">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen flex-col">
      <div className="flex items-center justify-between border-b border-gray-200 bg-white px-6 py-3">
        <div>
          <h1 className="text-lg font-semibold text-gray-900">Sources</h1>
          <p className="text-sm text-gray-500">
            Documents in the chatbot's knowledge base
          </p>
        </div>
        <button
          onClick={() => setIsUploadOpen(true)}
          className="flex items-center gap-1 rounded-md bg-blue-600 px-3 py-2 text-sm font-medium text-white hover:bg-blue-700"
        >
          <MdAdd size={18} />
          Upload
        </button>
      </div>

      <div className="flex-1 overflow-auto p-6">
        <DocumentList
          documents={documents}
          page={page}
          totalPages={totalPages}
          onPageChange={setPage}
        />
      </div>

      <UploadModal
        isOpen={isUploadOpen}
        onClose={() => setIsUploadOpen(false)}
      />
    </div>
  );
}
